import { Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import { ExperienceFieldType, ExperienceType } from 'app/typings/experiences';

import { OpeningHours } from '../FormItems/OpeningHours/OpeningHours';

import { AvailableOn } from './_components/AvailableOn';
import { ClosingPeriod } from './_components/ClosingPeriod';

export const Schedule = () => {
  const form = Form.useFormInstance();
  const categoryId = Form.useWatch(['categoryId'], form);

  const { data: experienceCategories } = useExperiencesCategories();

  const category = experienceCategories?.find((c) => c.id === categoryId);
  const isOriginal =
    Form.useWatch('experienceType', form) === ExperienceType.STAYCATION;

  return (
    <SCard
      title="Schedule"
      className="experience-form"
      subtitle={
        category?.openingHours !== ExperienceFieldType.NOT_APPLICABLE
          ? 'Add practical information regarding the opening hours of the experience. This information will be shown at the bottom of the Package page.'
          : undefined
      }
    >
      {category?.openingHours !== ExperienceFieldType.NOT_APPLICABLE && (
        <OpeningHours />
      )}
      {!isOriginal && <AvailableOn />}
      <ClosingPeriod />
    </SCard>
  );
};
